import { useState, useEffect, useRef } from "react";
import Pause from "../Components/Pause";
import Win from "../Components/Win";
import { FaUserAstronaut } from "react-icons/fa";
import { FaCrown } from "react-icons/fa";
import { FaAnchor } from "react-icons/fa";
import { FaCrow } from "react-icons/fa";
import { FaBolt } from "react-icons/fa";
import { FaGamepad } from "react-icons/fa";
import { FaMoon } from "react-icons/fa";
import { FaPaw } from "react-icons/fa";
import { FaMask } from "react-icons/fa";
import { FaPaperclip } from "react-icons/fa";
import { FaMoneyBillWave } from "react-icons/fa";
import { FaHeadphonesAlt } from "react-icons/fa";
import { FaKey } from "react-icons/fa";
import { FaCloud } from "react-icons/fa";
import { FaDiceSix } from "react-icons/fa";
import { FaGem } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { FaFlask } from "react-icons/fa";
import { FaGhost } from "react-icons/fa";

function Board(props) {
  const [pause, setPause] = useState(false);
  const [selectedButtonActive, setSelectedButtonActive] = useState();
  const [memory, setMemory] = useState([]);
  const [winningPair, setWinningPair] = useState([]);
  const [matchPair, setMatchPair] = useState([]);
  const [points, setPoints] = useState([]);
  const [time, setTime] = useState(0);
  const [playerTurn, setPlayerTurn] = useState([0]);
  const [playerActive, setPlayerActive] = useState([true]);
  const [points1, setPoints1] = useState([]);
  const [points2, setPoints2] = useState([]);
  const [points3, setPoints3] = useState([]);
  const [points4, setPoints4] = useState([]);
  const [showButton, setShowButton] = useState(true);
  const [turnHighlight, setTurnHighlight] = useState(false);

  let stopTime = useRef();

  const icons = [
    {
      icon: <FaUserAstronaut />,
      number: "10",
    },
    {
      icon: <FaUserAstronaut />,
      number: "11",
    },
    {
      icon: <FaCrown />,
      number: "20",
    },
    {
      icon: <FaCrown />,
      number: "21",
    },
    {
      icon: <FaAnchor />,
      number: "30",
    },
    {
      icon: <FaAnchor />,
      number: "31",
    },
    {
      icon: <FaCrow />,
      number: "40",
    },
    {
      icon: <FaCrow />,
      number: "41",
    },
    {
      icon: <FaBolt />,
      number: "50",
    },
    {
      icon: <FaBolt />,
      number: "51",
    },
    {
      icon: <FaGamepad />,
      number: "60",
    },
    {
      icon: <FaGamepad />,
      number: "61",
    },
    {
      icon: <FaMoon />,
      number: "70",
    },
    {
      icon: <FaMoon />,
      number: "71",
    },
    {
      icon: <FaPaw />,
      number: "80",
    },
    {
      icon: <FaPaw />,
      number: "81",
    },
    {
      icon: <FaMask />,
      number: "90",
    },
    {
      icon: <FaMask />,
      number: "91",
    },
    {
      icon: <FaPaperclip />,
      number: "100",
    },
    {
      icon: <FaPaperclip />,
      number: "101",
    },
    {
      icon: <FaMoneyBillWave />,
      number: "110",
    },
    {
      icon: <FaMoneyBillWave />,
      number: "111",
    },
    {
      icon: <FaHeadphonesAlt />,
      number: "120",
    },
    {
      icon: <FaHeadphonesAlt />,
      number: "121",
    },
    {
      icon: <FaKey />,
      number: "120",
    },
    {
      icon: <FaKey />,
      number: "121",
    },
    {
      icon: <FaCloud />,
      number: "130",
    },
    {
      icon: <FaCloud />,
      number: "131",
    },
    {
      icon: <FaDiceSix />,
      number: "140",
    },
    {
      icon: <FaDiceSix />,
      number: "141",
    },
    {
      icon: <FaGem />,
      number: "150",
    },
    {
      icon: <FaGem />,
      number: "151",
    },
    {
      icon: <FaHeart />,
      number: "160",
    },
    {
      icon: <FaHeart />,
      number: "161",
    },
    {
      icon: <FaFlask />,
      number: "170",
    },
    {
      icon: <FaFlask />,
      number: "171",
    },
    {
      icon: <FaGhost />,
      number: "180",
    },
    {
      icon: <FaGhost />,
      number: "181",
    },
  ];

  useEffect(() => {
    addPoints();
    changeTurnHighlight();
    if (memory.length === 1) {
      stopTime = setInterval(timer, 1000);
      console.log(memory.length);
    }
  }, [memory]);

  useEffect(() => {
    if (props.gameActive) {
      setTimeout(() => {
        setShowButton(false);
      }, 4000);
    }
  }, [props.gameActive]);

  function restartShowButton() {
    if (props.gameActive) {
      setTimeout(() => {
        setShowButton(false);
      }, 4000);
    }
  }

  function timer() {
    setTime((prevTimer) => prevTimer + 1);
  }

  function changeTurnHighlight() {
    setTurnHighlight(!turnHighlight);
  }

  function givePoints4() {
    setPlayerTurn([...playerTurn, 1]);
    if (playerTurn.length % 2 === 0) {
      switch (true) {
        case playerActive[0]:
          setPlayerActive([false, true, false, false]);
          break;
        case playerActive[1]:
          setPlayerActive([false, false, true, false]);
          break;
        case playerActive[2]:
          setPlayerActive([false, false, false, true]);
          break;
        case playerActive[3]:
          setPlayerActive([true, false, false, false]);
          break;
      }
    }
  }
  function givePoints3() {
    setPlayerTurn([...playerTurn, 1]);
    if (playerTurn.length % 2 === 0) {
      switch (true) {
        case playerActive[0]:
          setPlayerActive([false, true, false]);
          break;
        case playerActive[1]:
          setPlayerActive([false, false, true]);
          break;
        case playerActive[2]:
          setPlayerActive([true, false, false]);
          break;
      }
    }
  }

  function givePoints2() {
    setPlayerTurn([...playerTurn, 1]);
    if (playerTurn.length % 2 === 0) {
      switch (true) {
        case playerActive[0]:
          setPlayerActive([false, true]);
          break;
        case playerActive[1]:
          setPlayerActive([true, false]);
          break;
      }
    }
  }

  function logic(e) {
    if (!showButton) {
      setSelectedButtonActive(e);
      setMatchPair([...matchPair, e]);
      setMemory([...memory, e]);
      if (props.players.length === 2) {
        givePoints2();
      } else if (props.players.length === 3) {
        givePoints3();
      } else if (props.players.length === 4) {
        givePoints4();
      }
    }
  }

  function addPoints() {
    if (
      Number(matchPair[matchPair.length - 1]) + 1 ===
        Number(matchPair[matchPair.length - 2]) &&
      !winningPair.includes(matchPair[matchPair.length - 1]) &&
      !winningPair.includes(matchPair[matchPair.length - 2])
    ) {
      setPoints([...points, 1]);
      setWinningPair([
        ...winningPair,
        matchPair[matchPair.length - 2],
        matchPair[matchPair.length - 1],
      ]);
      if (props.players.length === 2) {
        if (playerActive[0]) {
          setPoints2([...points2, 1]);
        } else if (playerActive[1]) {
          setPoints1([...points1, 1]);
        }
      } else if (props.players.length === 3) {
        if (playerActive[0]) {
          setPoints3([...points3, 1]);
        } else if (playerActive[1]) {
          setPoints1([...points1, 1]);
        } else if (playerActive[2]) {
          setPoints2([...points2, 1]);
        }
      } else if (props.players.length === 4) {
        if (playerActive[0]) {
          setPoints4([...points4, 1]);
        } else if (playerActive[1]) {
          setPoints1([...points1, 1]);
        } else if (playerActive[2]) {
          setPoints2([...points2, 1]);
        } else if (playerActive[3]) {
          setPoints3([...points3, 1]);
        }
      }
    } else if (
      Number(matchPair[matchPair.length - 1]) - 1 ===
        Number(matchPair[matchPair.length - 2]) &&
      !winningPair.includes(matchPair[matchPair.length - 1]) &&
      !winningPair.includes(matchPair[matchPair.length - 2])
    ) {
      setPoints([...points, 1]);
      setWinningPair([
        ...winningPair,
        matchPair[matchPair.length - 2],
        matchPair[matchPair.length - 1],
      ]);
      if (props.players.length === 2) {
        if (playerActive[0]) {
          setPoints2([...points2, 1]);
        } else if (playerActive[1]) {
          setPoints1([...points1, 1]);
        }
      } else if (props.players.length === 3) {
        if (playerActive[0]) {
          setPoints3([...points3, 1]);
        } else if (playerActive[1]) {
          setPoints1([...points1, 1]);
        } else if (playerActive[2]) {
          setPoints2([...points2, 1]);
        }
      } else if (props.players.length === 4) {
        if (playerActive[0]) {
          setPoints4([...points4, 1]);
        } else if (playerActive[1]) {
          setPoints1([...points1, 1]);
        } else if (playerActive[2]) {
          setPoints2([...points2, 1]);
        } else if (playerActive[3]) {
          setPoints3([...points3, 1]);
        }
      }
    } else {
    }
  }

  function onPause() {
    setPause(!pause);
  }

  function restart() {
    setSelectedButtonActive();
    setMemory([]);
    setWinningPair([]);
    setMatchPair([]);
    setPoints([]);
    setPoints1([]);
    setPoints2([]);
    setPoints3([]);
    setPoints4([]);
    setPause(false);
    setPlayerActive([true]);
    setPlayerTurn([0]);
    setShowButton(true);
    restartShowButton();
    setTurnHighlight(false);
    clearInterval(stopTime);
    setTime(0);
  }

  function newGame() {
    setSelectedButtonActive();
    setMemory([]);
    setWinningPair([]);
    setMatchPair([]);
    setPoints([]);
    setPoints1([]);
    setPoints2([]);
    setPoints3([]);
    setPoints4([]);
    setPause(false);
    setPlayerActive([true]);
    setPlayerTurn([0]);
    props.setGameActive(false);
    setShowButton(true);
    setTurnHighlight(false);
    clearInterval(stopTime);
    setTime(0);
  }

  return (
    <div className={props.gameActive ? "board-screen" : "off"}>
      <Pause
        pause={pause}
        changePause={onPause}
        restart={restart}
        newGame={newGame}
      />
      <Win
        grid={props.grid}
        winningPair={winningPair}
        restart={restart}
        newGame={newGame}
        moves={memory.length}
        players={props.players}
        memory={memory}
        points1={points1.length}
        points2={points2.length}
        points3={points3.length}
        points4={points4.length}
        time={time}
        setTime={setTime}
        timer={timer}
      />
      <header className="board-screen-header">
        <h2 onClick={() => console.log(icons.find((x) => x.icon).icon)}>
          memory
        </h2>
        <button onClick={onPause}>Menu</button>
      </header>

      <div className={props.grid === "4x4" ? "board4" : "board6"}>
        {props.gridArray.map((num) => (
          <button
            key={num}
            onClick={() => logic(num)}
            id={showButton ? "show" : ""}
            className={
              selectedButtonActive === num
                ? "board-buttons"
                : "" || winningPair.includes(num)
                ? "board-buttons-match"
                : ""
            }
          >
            {props.theme === "Numbers"
              ? num.length === 2
                ? num[0]
                : num.slice(0, 2)
              : icons.find((x) => x.number === num)
              ? icons.find((x) => x.number === num).icon
              : ""}
          </button>
        ))}
      </div>
      <div className="solo-tracker">
        <div className={props.players.length === 1 ? "solo-cards" : "off"}>
          <h3>Time</h3>
          <p>
            {winningPair.length === 16 ? "--" : Math.floor(time / 60)}:
            {winningPair.length === 16
              ? "--"
              : parseInt(time % 60) < 10
              ? "0" + parseInt(time % 60)
              : parseInt(time % 60)}
          </p>
        </div>
        <div className={props.players.length === 1 ? "solo-cards" : "off"}>
          <h3>Moves</h3>
          <p>{memory.length}</p>
        </div>
      </div>
      <div className={props.players.length > 1 ? "points-container" : "off"}>
        <div
          className={
            playerActive[0]
              ? "points-current-card"
              : "points-card" && props.players.length > 1
              ? "points-card"
              : "off"
          }
        >
          <h3>P1</h3>
          <p>{points1.length}</p>
          <div className={playerActive[0] ? "dots" : "off"}>
            <p className={turnHighlight ? "dot-active" : "dot"}></p>
            <p className={turnHighlight ? "dot" : "dot-active"}></p>
          </div>
        </div>
        <div
          className={
            playerActive[1]
              ? "points-current-card"
              : "points-card" && props.players.length > 1
              ? "points-card"
              : "off"
          }
        >
          <h3>P2</h3>
          <p>{points2.length}</p>
          <div className={playerActive[1] ? "dots" : "off"}>
            <p className={turnHighlight ? "dot-active" : "dot"}></p>
            <p className={turnHighlight ? "dot" : "dot-active"}></p>
          </div>
        </div>
        <div
          className={
            playerActive[2]
              ? "points-current-card"
              : "points-card" && props.players.length > 2
              ? "points-card"
              : "off"
          }
        >
          <h3>P3</h3>
          <p>{points3.length}</p>
          <div className={playerActive[2] ? "dots" : "off"}>
            <p className={turnHighlight ? "dot-active" : "dot"}></p>
            <p className={turnHighlight ? "dot" : "dot-active"}></p>
          </div>
        </div>
        <div
          className={
            playerActive[3]
              ? "points-current-card"
              : "points-card" && props.players.length === 4
              ? "points-card"
              : "off"
          }
        >
          <h3>P4</h3>
          <p>{points4.length}</p>
          <div className={playerActive[3] ? "dots" : "off"}>
            <p className={turnHighlight ? "dot-active" : "dot"}></p>
            <p className={turnHighlight ? "dot" : "dot-active"}></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Board;
